export default __webpack_public_path__ + "63493572f921ffb70494755e5c6dbcf6.svg";